import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { toast } from "sonner";

const Login = () => {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome!");
      navigate("/account");
    } catch {
      toast.error(t("auth.loginError"));
    } finally {
      setSubmitting(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="max-w-[440px] mx-auto px-6 py-20">
      <p className="overline mb-3 text-center">Amazypet</p>
      <h1 className="font-serif text-4xl text-center mb-10">{t("auth.loginTitle")}</h1>

      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="overline mb-1 block">{t("auth.email")}</label>
          <input type="email" required className="luxury-input-box" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <label className="overline mb-1 block">{t("auth.password")}</label>
          <input type="password" required className="luxury-input-box" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        <button type="submit" disabled={submitting} className="luxury-btn w-full" data-testid="login-submit">
          {submitting ? "..." : t("auth.submitLogin")}
        </button>
      </form>

      <div className="flex items-center my-8 gap-4 text-xs text-[#736B66] uppercase tracking-widest">
        <div className="h-px bg-[#EBE5DF] flex-1" />
        {t("auth.orWith")}
        <div className="h-px bg-[#EBE5DF] flex-1" />
      </div>

      <button onClick={googleLogin} className="luxury-btn-outline w-full" data-testid="google-login">
        <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
        {t("auth.googleLogin")}
      </button>

      <p className="text-center text-sm text-[#736B66] mt-8">
        {t("auth.noAccount")} <Link to="/register" className="text-[#2C1E16] underline">{t("auth.createOne")}</Link>
      </p>
    </div>
  );
};

export default Login;
